import * as R from './Record';
/**
 * @category constructor
 * @since 2.2.0
 */
export var indexReadonlyRecord = R.indexRecord;
